import classNames from 'classnames'
import React from 'react'
import { useTranslation } from 'react-i18next'

import { Carousel } from '@ui/Carousel/Carousel'
import { CarouselChild } from '@ui/Carousel/CarouselItem'
import { Heading4, Title1 } from '@ui/Typography'

import { ClientBaseIcon } from './assets/ClientBaseIcon'
import { EarnFromTradesIcon } from './assets/EarnFromTradesIcon'
import { ManageFundsIcon1 } from './assets/ManageFundsIcon1'
import { ManageFundsIcon2 } from './assets/ManageFundsIcon2'
import { RewardsIcon } from './assets/RewardsIcon'

import styles from './IBCarousel.module.scss'

export const IBDefaultCarousel: React.FC = () => {
  const { t } = useTranslation()

  return (
    <Carousel loop className={styles.carousel} interval={4000}>
      <CarouselChild className={styles.carouselChild}>
        <div className={styles.iconContainer}>
          <div className={styles.subWrapper}>
            <ClientBaseIcon className={styles.clientBaseIcon} />
          </div>
          <div className={styles.subWrapper}>
            <ClientBaseIcon className={styles.clientBaseIcon} />
          </div>
          <div className={styles.subWrapper}>
            <ClientBaseIcon className={styles.clientBaseIcon} />
          </div>
        </div>
        <Heading4 className={styles.title}>{t('IB.Carousel.Build your client base')}</Heading4>
        <Title1
          isParagraph
          dangerouslySetInnerHTML={{
            __html: t('IB.Carousel.Recommend Tickmill to other traders', {
              interpolation: { escapeValue: false },
            }),
          }}
        />
      </CarouselChild>
      <CarouselChild className={styles.carouselChild}>
        <div className={styles.iconWrapper}>
          <EarnFromTradesIcon className={styles.icon} />
        </div>
        <Heading4 className={styles.title}>{t('IB.Carousel.Earn from trades')}</Heading4>
        <Title1 isParagraph>
          {t('IB.The more your clients trade, the bigger is your reward. The reward is calculated')}
        </Title1>
      </CarouselChild>
      <CarouselChild className={styles.carouselChild}>
        <div className={classNames(styles.iconWrapper, styles.dualIcon)}>
          <ManageFundsIcon1 className={styles.icon} />
          <ManageFundsIcon2 className={styles.icon} />
        </div>
        <Heading4 className={styles.title}>{t('IB.Carousel.Manage your funds')}</Heading4>
        <Title1
          isParagraph
          dangerouslySetInnerHTML={{
            __html: t('IB.Carousel.Access and manage', {
              interpolation: { escapeValue: false },
            }),
          }}
        />
      </CarouselChild>
      <CarouselChild className={styles.carouselChild}>
        <div className={classNames(styles.iconWrapper, styles.smallPad)}>
          <RewardsIcon className={styles.icon} />
        </div>
        <Heading4 className={styles.title}>{t('IB.Carousel.Tickmill rewards you')}</Heading4>
        <Title1
          isParagraph
          dangerouslySetInnerHTML={{
            __html: t('IB.Carousel.Grow your Network, Climb the Tiers', {
              interpolation: { escapeValue: false },
            }),
          }}
        />
        <Title1 isParagraph className={styles.terms}>
          {t('IB.Carousel.terms')}
        </Title1>
      </CarouselChild>
    </Carousel>
  )
}
